export default __webpack_public_path__ + "static/media/461.7568a925.gif";